import { Page } from '../types';
import { Icon } from './Icon';

type NavigationItem = { id: Page; label: string; icon: string };
type Props = {
  page: Page;
  navigation: NavigationItem[];
  unit: string;
  mobileOpen: boolean;
  onNavigate: (page: Page) => void;
  onUnitChange: (unit: string) => void;
};

export function Sidebar({ page, navigation, unit, mobileOpen, onNavigate, onUnitChange }: Props) {
  return <aside className={`sidebar ${mobileOpen ? 'sidebar-open' : ''}`}>
    <div className="brand"><span className="brand-mark"><span/><span/><span/></span><span>repday<span className="brand-dot">.</span></span></div>
    <div className="side-label">MENU</div>
    <nav>{navigation.map(item => <button key={item.id} className={`nav-item ${page === item.id ? 'active' : ''}`} onClick={() => onNavigate(item.id)}><Icon name={item.icon}/><span>{item.label}</span>{item.id === 'workout' && <span className="nav-plus">+</span>}</button>)}</nav>
    <div className="sidebar-bottom"><div className="side-label">YOUR DATA</div><div className="privacy-note"><span className="privacy-dot"/><div><strong>Private by design</strong><small>Your logs stay on this device</small></div></div><div className="unit-setting"><span>Weight unit</span><select value={unit} onChange={event => onUnitChange(event.target.value)}><option value="kg">Kilograms · kg</option><option value="lb">Pounds · lb</option></select></div></div>
  </aside>;
}
